/* assets/cf-contact-form.js */
(function () {
  "use strict";

  var form = document.getElementById("fa-form-1");
  if (!form) return;

  // --- CONFIG (from DOM data attributes) ---
  var CONFIG = {
    workerUrl: form.getAttribute("data-worker-url") || "",
    siteKey: form.getAttribute("data-site-key") || "",
    maxFiles: 10,
    maxTotalSize: 20 * 1024 * 1024, // 20 MB
    maxSingleSize: 10 * 1024 * 1024, // 10 MB per file
    fetchTimeout: 30000, // 30 s
    allowedTypes: [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/webp",
      "application/pdf",
    ],
  };

  // --- CACHED DOM REFS ---
  var els = {
    btn: document.getElementById("submit-btn"),
    tokenInput: document.getElementById("cf-turnstile-response"),
    name: document.getElementById("name"),
    email: document.getElementById("email"),
    enquiryType: document.getElementById("enquiryType"),
    countryType: document.getElementById("countryType"),
    enquiryMessage: document.getElementById("enquiryMessage"),
    orderNumber: document.getElementById("orderNumber"),
    attachment: document.getElementById("attachment"),
    startTime: document.getElementById("startTime"),
    popupMsg: document.getElementById("popup-message"),
    popup: document.getElementById("popup"),
    overlay: document.getElementById("overlay"),
    closePopup: document.getElementById("close-popup"),
    charCount: document.getElementById("msg-char-count"),
    fileList: document.getElementById("file-list"),
    fileSummary: document.getElementById("file-summary"),
    dropZone: document.getElementById("file-drop-zone"),
    iconSuccess: document.getElementById("popup-icon-success"),
    iconError: document.getElementById("popup-icon-error"),
    honeypot: document.getElementById("fa-website"),
  };

  var state = {
    token: "",
    widgetId: null,
    submitting: false,
    selectedFiles: [],
    formDirty: false,
  };

  // --- UTILS ---

  /** Debounce helper – avoids hammering validate() on every keystroke */
  function debounce(fn, delay) {
    var timer;
    return function () {
      var ctx = this,
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, delay);
    };
  }

  /** Show / hide a single field-tooltip and set aria-invalid */
  function toggleError(id, hasError) {
    var tooltip = document.getElementById(id + "-tooltip");
    if (!tooltip) return;

    // For the recaptcha tooltip there is no matching input element —
    // fall back to the hidden tokenInput so "touched" tracking works.
    var input =
      document.getElementById(id) ||
      (id === "recaptcha" ? els.tokenInput : null);
    var isTouched = input && input.getAttribute("data-touched") === "true";

    if (isTouched && hasError) {
      tooltip.style.display = "block";
      tooltip.setAttribute("role", "alert");
      if (input) input.setAttribute("aria-invalid", "true");
    } else {
      tooltip.style.display = "none";
      tooltip.removeAttribute("role");
      if (input) input.setAttribute("aria-invalid", "false");
    }
  }

  /** Very basic order-number format check */
  function isValidOrder(val) {
    if (!val) return true;
    return /^#?\d{6,10}$/.test(val) || /^(US|EU|CA)\d{4,10}$/i.test(val);
  }

  /** Format bytes to human-readable string */
  function formatBytes(bytes) {
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1048576) return (bytes / 1024).toFixed(1) + " KB";
    return (bytes / 1048576).toFixed(1) + " MB";
  }

  // --- DYNAMIC INLINE HINTS ---

  /** Show or hide a field-hint element, optional text + class */
  function setHint(id, text, extraClass) {
    var el = document.getElementById(id);
    if (!el) return;
    if (text) {
      el.textContent = text;
      el.className =
        "field-hint visible" + (extraClass ? " " + extraClass : "");
    } else {
      el.className = "field-hint";
    }
  }

  /** Compute contextual hint for the name field */
  function hintName() {
    var v = els.name.value.trim();
    if (!v) {
      setHint("name-hint", "Enter your first and last name.");
    } else if (v.length < 2) {
      setHint("name-hint", "Name seems too short.", "hint-warning");
    } else {
      setHint("name-hint", null);
    }
  }

  /** Compute contextual hint for the email field */
  function hintEmail() {
    var v = els.email.value.trim();
    if (!v) {
      setHint("email-hint", "We\u2019ll only use this to reply to you.");
    } else if (v.indexOf("@") === -1) {
      setHint("email-hint", "Don\u2019t forget the @ symbol.", "hint-warning");
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
      setHint("email-hint", "Double-check your email address.", "hint-warning");
    } else {
      setHint("email-hint", "Looks good!", "hint-success");
    }
  }

  /** Compute contextual hint for the order number field */
  function hintOrder() {
    var v = els.orderNumber.value.trim();
    if (!v) {
      setHint(
        "orderNumber-hint",
        "Format: #123456 or US1234 \u2014 found in your confirmation email.",
      );
    } else if (!isValidOrder(v)) {
      setHint(
        "orderNumber-hint",
        "Try #123456 or US1234 format.",
        "hint-warning",
      );
    } else {
      setHint("orderNumber-hint", null);
    }
  }

  /** Compute contextual hint for the message field */
  function hintMessage() {
    var len = els.enquiryMessage.value.length;
    if (len === 0) {
      setHint(
        "msg-hint",
        "Describe your issue in detail so we can help faster.",
      );
    } else if (len < 20) {
      setHint(
        "msg-hint",
        "A bit more detail helps us respond faster.",
        "hint-warning",
      );
    } else {
      setHint("msg-hint", null);
    }
  }

  /** Map of field id -> hint function */
  var hintMap = {};
  hintMap["name"] = hintName;
  hintMap["email"] = hintEmail;
  hintMap["orderNumber"] = hintOrder;
  hintMap["enquiryMessage"] = hintMessage;

  /** Run the appropriate hint for a field, if any */
  function updateHint(fieldId) {
    var fn = hintMap[fieldId];
    if (fn) fn();
  }

  // --- SELECT PLACEHOLDER CLASS ---
  /** Toggle .placeholder-shown on selects so CSS can gray out unselected state */
  function updateSelectClass(selectEl) {
    if (!selectEl) return;
    if (selectEl.value === "") {
      selectEl.className = (
        selectEl.className.replace(/\bplaceholder-shown\b/g, "").trim() +
        " placeholder-shown"
      ).trim();
    } else {
      selectEl.className = selectEl.className
        .replace(/\bplaceholder-shown\b/g, "")
        .trim();
    }
  }

  // --- VALIDATION ---
  function validate() {
    var vals = {
      name: els.name.value.trim(),
      email: els.email.value.trim(),
      type: els.enquiryType.value,
      country: els.countryType.value,
      msg: els.enquiryMessage.value.trim(),
      order: els.orderNumber.value.trim(),
      token: state.token,
    };

    var errors = {
      name: !vals.name,
      email: !vals.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(vals.email),
      enquiryType: !vals.type,
      countryType: !vals.country,
      enquiryMessage: !vals.msg,
      orderNumber: vals.order !== "" && !isValidOrder(vals.order),
      recaptcha: !vals.token,
    };

    toggleError("name", errors.name);
    toggleError("email", errors.email);
    toggleError("enquiryType", errors.enquiryType);
    toggleError("countryType", errors.countryType);
    toggleError("enquiryMessage", errors.enquiryMessage);
    toggleError("orderNumber", errors.orderNumber);
    toggleError("recaptcha", errors.recaptcha);

    // File validation (show via attachment tooltip)
    var fileError = validateFiles(false);
    toggleError("attachment", fileError);

    var hasError = false;
    for (var key in errors) {
      if (errors[key]) {
        hasError = true;
        break;
      }
    }
    hasError = hasError || fileError;

    els.btn.disabled = hasError || state.submitting;
    els.btn.setAttribute("aria-disabled", String(hasError || state.submitting));
    return !hasError;
  }

  /** Validate file constraints. Returns true if there IS an error. */
  function validateFiles(showAlert) {
    var files = state.selectedFiles;
    if (!files || files.length === 0) return false;

    if (files.length > CONFIG.maxFiles) {
      if (showAlert)
        showPopup("Maximum " + CONFIG.maxFiles + " files allowed.", "error");
      return true;
    }

    var totalSize = 0;
    for (var i = 0; i < files.length; i++) {
      var f = files[i];
      totalSize += f.size;

      // Individual file size
      if (f.size > CONFIG.maxSingleSize) {
        if (showAlert)
          showPopup(
            '"' + f.name + '" exceeds the 10 MB per-file limit.',
            "error",
          );
        return true;
      }

      // File type check (graceful – skip on browsers without File.type)
      if (f.type && CONFIG.allowedTypes.indexOf(f.type) === -1) {
        if (showAlert)
          showPopup(
            '"' +
              f.name +
              '" is not an accepted file type. Please upload images or PDFs.',
            "error",
          );
        return true;
      }
    }

    if (totalSize > CONFIG.maxTotalSize) {
      if (showAlert)
        showPopup(
          "Total attachment size (" +
            formatBytes(totalSize) +
            ") exceeds the 20 MB limit.",
          "error",
        );
      return true;
    }
    return false;
  }

  // --- FILE MANAGEMENT ---

  /**
   * Rebuild the hidden file input with a DataTransfer (where supported)
   * so FormData picks up the current selectedFiles array.
   */
  function syncFileInput() {
    if (typeof DataTransfer !== "undefined") {
      var dt = new DataTransfer();
      for (var i = 0; i < state.selectedFiles.length; i++) {
        dt.items.add(state.selectedFiles[i]);
      }
      els.attachment.files = dt.files;
    }
  }

  /** Remove a file by index from selectedFiles */
  function removeFile(index) {
    state.selectedFiles.splice(index, 1);
    syncFileInput();
    renderFileList();
    updateFileSummary();
    validate();
  }

  /** Get the file-type category for icon color */
  function getFileType(file) {
    if (file.type && file.type.indexOf("image") === 0) return "image";
    if (file.type === "application/pdf") return "pdf";
    return "other";
  }

  /** Get short extension label */
  function getFileExt(name) {
    var parts = name.split(".");
    if (parts.length < 2) return "FILE";
    return parts[parts.length - 1].toUpperCase();
  }

  /** Render file list preview below drop zone with type icon and remove button */
  function renderFileList() {
    if (!els.fileList) return;
    els.fileList.innerHTML = "";
    var files = state.selectedFiles;
    if (!files || files.length === 0) return;

    for (var i = 0; i < files.length; i++) {
      var li = document.createElement("li");

      // Type icon
      var iconDiv = document.createElement("span");
      var ft = getFileType(files[i]);
      iconDiv.className = "file-type-icon type-" + ft;
      iconDiv.textContent = getFileExt(files[i].name);
      li.appendChild(iconDiv);

      // Info wrapper
      var infoDiv = document.createElement("span");
      infoDiv.className = "file-info";
      var nameSpan = document.createElement("span");
      nameSpan.className = "file-name";
      nameSpan.textContent = files[i].name;
      var sizeSpan = document.createElement("span");
      sizeSpan.className = "file-size";
      sizeSpan.textContent = formatBytes(files[i].size);
      infoDiv.appendChild(nameSpan);
      infoDiv.appendChild(sizeSpan);
      li.appendChild(infoDiv);

      // Remove button
      var removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.className = "file-remove";
      removeBtn.setAttribute("aria-label", "Remove " + files[i].name);
      removeBtn.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      (function (idx) {
        removeBtn.addEventListener("click", function () {
          removeFile(idx);
        });
      })(i);
      li.appendChild(removeBtn);

      els.fileList.appendChild(li);
    }
  }

  /** Update the file count / size summary below file list */
  function updateFileSummary() {
    if (!els.fileSummary) return;
    var files = state.selectedFiles;
    if (!files || files.length === 0) {
      els.fileSummary.textContent = "";
      return;
    }
    var total = 0;
    for (var i = 0; i < files.length; i++) total += files[i].size;
    els.fileSummary.textContent =
      files.length +
      " file" +
      (files.length !== 1 ? "s" : "") +
      " \u2022 " +
      formatBytes(total) +
      " of 20 MB used";
  }

  // --- HANDLERS ---

  var debouncedValidate = debounce(validate, 150);

  /** Update character counter for message field */
  function updateCharCount() {
    if (!els.charCount) return;
    var len = els.enquiryMessage.value.length;
    var max = 2000;
    var formatted = len.toLocaleString ? len.toLocaleString() : len;
    var maxFormatted = max.toLocaleString ? max.toLocaleString() : max;
    els.charCount.textContent = formatted + " / " + maxFormatted;
    els.charCount.style.color = len > max * 0.9 ? "#d32f2f" : "";
  }

  function handleInput(e) {
    var target = e.target;
    state.formDirty = true;

    if (e.type === "blur" || e.type === "focusout") {
      target.setAttribute("data-touched", "true");
      validate(); // immediate on blur so user sees error right away
    } else {
      debouncedValidate();
    }

    // Always update char count immediately (no debounce)
    if (target === els.enquiryMessage) updateCharCount();

    // Dynamic inline hints
    if (target.id) updateHint(target.id);

    // Select placeholder class
    if (target.tagName === "SELECT") updateSelectClass(target);

    // Auto-save to sessionStorage
    saveFormState();
  }

  function handleFile(e) {
    var input = e.target;
    input.setAttribute("data-touched", "true");

    // Merge newly chosen files into selectedFiles
    if (input.files && input.files.length > 0) {
      for (var i = 0; i < input.files.length; i++) {
        state.selectedFiles.push(input.files[i]);
      }
    }

    // Enforce max files
    if (state.selectedFiles.length > CONFIG.maxFiles) {
      state.selectedFiles = state.selectedFiles.slice(0, CONFIG.maxFiles);
    }

    syncFileInput();

    if (validateFiles(true)) {
      // remove the last batch on error
      state.selectedFiles = [];
      syncFileInput();
    }
    renderFileList();
    updateFileSummary();
    validate();
  }

  // --- SUBMIT ---
  function handleSubmit(e) {
    e.preventDefault();
    if (state.submitting) return; // prevent double-submit

    // Honeypot check – bots fill hidden fields, real users don't
    if (els.honeypot && els.honeypot.value) {
      // Silently reject – don't reveal the trap
      showPopup(
        "Message sent successfully! We will get back to you soon.",
        "success",
      );
      resetForm();
      return;
    }

    // Mark all fields as touched so errors surface
    var fields = form.querySelectorAll("input, select, textarea");
    for (var i = 0; i < fields.length; i++)
      fields[i].setAttribute("data-touched", "true");
    els.tokenInput.setAttribute("data-touched", "true");

    if (!validate()) {
      var firstErr = form.querySelector('.field-tooltip[style*="block"]');
      if (firstErr)
        firstErr.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    if (
      typeof navigator !== "undefined" &&
      "onLine" in navigator &&
      !navigator.onLine
    ) {
      showPopup(
        "You appear to be offline. Please check your internet connection and try again.",
        "error",
      );
      return;
    }

    state.submitting = true;
    els.btn.disabled = true;
    els.btn.setAttribute("aria-busy", "true");
    els.btn.innerHTML =
      '<span class="spinner" aria-hidden="true"></span> Sending\u2026';

    var formData = new FormData(form);

    // AbortController for fetch timeout (with fallback for older browsers)
    var controller =
      typeof AbortController !== "undefined" ? new AbortController() : null;
    var timeoutId = null;

    if (controller) {
      timeoutId = setTimeout(function () {
        controller.abort();
      }, CONFIG.fetchTimeout);
    }

    var fetchOpts = { method: "POST", body: formData };
    if (controller) fetchOpts.signal = controller.signal;

    fetch(CONFIG.workerUrl, fetchOpts)
      .then(function (res) {
        if (timeoutId) clearTimeout(timeoutId);
        return res.text().then(function (text) {
          return { ok: res.ok, status: res.status, body: text };
        });
      })
      .then(function (result) {
        if (result.ok && result.body.trim() === "ok") {
          showPopup(
            "Message sent successfully! We will get back to you soon.",
            "success",
          );
          resetForm();
        } else if (result.status === 429) {
          showPopup(
            "Too many requests. Please wait a moment and try again.",
            "error",
          );
        } else {
          console.error("Server Error (" + result.status + "):", result.body);
          showPopup(
            "Something went wrong on our end. Please try again later.",
            "error",
          );
        }
      })
      .catch(function (err) {
        if (timeoutId) clearTimeout(timeoutId);
        if (err && err.name === "AbortError") {
          showPopup(
            "The request timed out. Please check your connection and try again.",
            "error",
          );
        } else if (
          typeof navigator !== "undefined" &&
          "onLine" in navigator &&
          !navigator.onLine
        ) {
          showPopup(
            "You appear to be offline. Please check your internet connection.",
            "error",
          );
        } else {
          console.error("Network Error:", err);
          showPopup("A network error occurred. Please try again.", "error");
        }
      })
      .then(function () {
        // "finally" equivalent for older browsers that lack Promise.prototype.finally
        state.submitting = false;
        els.btn.disabled = false;
        els.btn.removeAttribute("aria-busy");
        els.btn.textContent = "Send Message";
        validate();
      });
  }

  // --- RESET ---
  function resetForm() {
    form.reset();
    var touched = document.querySelectorAll("[data-touched]");
    for (var i = 0; i < touched.length; i++)
      touched[i].setAttribute("data-touched", "false");
    var tooltips = form.querySelectorAll(".field-tooltip");
    for (var j = 0; j < tooltips.length; j++)
      tooltips[j].style.display = "none";
    state.token = "";
    state.selectedFiles = [];
    state.formDirty = false;
    els.tokenInput.value = "";
    if (els.fileList) els.fileList.innerHTML = "";
    if (els.fileSummary) els.fileSummary.textContent = "";
    updateCharCount();
    // Reset select placeholder classes
    updateSelectClass(els.enquiryType);
    updateSelectClass(els.countryType);
    // Hide all hints
    var hints = form.querySelectorAll(".field-hint");
    for (var h = 0; h < hints.length; h++) hints[h].className = "field-hint";
    // Clear autosaved data
    clearFormState();
    if (window.turnstile && state.widgetId !== null) {
      try {
        turnstile.reset(state.widgetId);
      } catch (e) {
        /* swallow */
      }
    }
  }

  // --- POPUP ---
  function showPopup(msg, type) {
    els.popupMsg.textContent = msg; // textContent prevents XSS
    els.popup.className = type;
    // Toggle icon visibility
    if (els.iconSuccess)
      els.iconSuccess.style.display = type === "success" ? "block" : "none";
    if (els.iconError)
      els.iconError.style.display = type === "error" ? "block" : "none";
    els.overlay.style.display = "flex";
    els.closePopup.focus(); // move focus into popup for a11y
  }

  function closePopup() {
    els.overlay.style.display = "none";
    els.btn.focus(); // return focus to form
  }

  // Focus trap inside modal – Tab/Shift+Tab loops within popup
  function handlePopupTab(e) {
    if (els.overlay.style.display !== "flex") return;
    if (e.key !== "Tab" && e.keyCode !== 9) return;
    var focusable = els.popup.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  // Close popup on ESC, overlay click, or close button
  function handleOverlayKey(e) {
    if (
      (e.key === "Escape" || e.keyCode === 27) &&
      els.overlay.style.display === "flex"
    ) {
      closePopup();
    }
  }

  function handleOverlayClick(e) {
    if (e.target === els.overlay) closePopup();
  }

  // --- SESSION STORAGE AUTO-SAVE ---
  var STORAGE_KEY = "cf_contact_draft";

  /** Save text field values to sessionStorage */
  function saveFormState() {
    try {
      var data = {
        name: els.name.value,
        email: els.email.value,
        orderNumber: els.orderNumber.value,
        enquiryType: els.enquiryType.value,
        countryType: els.countryType.value,
        enquiryMessage: els.enquiryMessage.value,
      };
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      /* quota exceeded or private mode */
    }
  }

  /** Restore saved draft from sessionStorage */
  function restoreFormState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (data.name) els.name.value = data.name;
      if (data.email) els.email.value = data.email;
      if (data.orderNumber) els.orderNumber.value = data.orderNumber;
      if (data.enquiryType) {
        els.enquiryType.value = data.enquiryType;
        updateSelectClass(els.enquiryType);
      }
      if (data.countryType) {
        els.countryType.value = data.countryType;
        updateSelectClass(els.countryType);
      }
      if (data.enquiryMessage) els.enquiryMessage.value = data.enquiryMessage;
      updateCharCount();
      // Mark form dirty if data was restored
      if (data.name || data.email || data.enquiryMessage)
        state.formDirty = true;
    } catch (e) {
      /* corrupted data – ignore */
    }
  }

  /** Clear saved draft */
  function clearFormState() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* swallow */
    }
  }

  // --- BEFOREUNLOAD ---
  function handleBeforeUnload(e) {
    if (state.formDirty && !state.submitting) {
      e.preventDefault();
      e.returnValue = "";
    }
  }

  // --- TURNSTILE ---
  window.onTurnstileLoaded = function () {
    if (state.widgetId !== null) return;
    if (typeof turnstile === "undefined") return;

    state.widgetId = turnstile.render("#turnstile-container", {
      sitekey: CONFIG.siteKey,
      callback: function (token) {
        state.token = token;
        els.tokenInput.value = token;
        els.tokenInput.setAttribute("data-touched", "true");
        validate();
      },
      "expired-callback": function () {
        state.token = "";
        els.tokenInput.value = "";
        validate();
      },
      "error-callback": function () {
        state.token = "";
        els.tokenInput.value = "";
        validate();
      },
    });
  };

  // --- INIT ---
  function init() {
    els.startTime.value = Date.now();

    form.addEventListener("input", handleInput);
    form.addEventListener("focusout", handleInput);
    els.attachment.addEventListener("change", handleFile);
    els.closePopup.addEventListener("click", closePopup);
    els.overlay.addEventListener("click", handleOverlayClick);
    document.addEventListener("keydown", handleOverlayKey);
    document.addEventListener("keydown", handlePopupTab);
    form.addEventListener("submit", handleSubmit);
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Show dynamic hints on focus
    form.addEventListener("focusin", function (e) {
      if (e.target.id) updateHint(e.target.id);
    });

    // Initialize select placeholder classes
    updateSelectClass(els.enquiryType);
    updateSelectClass(els.countryType);

    // Drag-and-drop visual feedback on the drop zone
    if (els.dropZone) {
      var preventDefaults = function (e) {
        e.preventDefault();
        e.stopPropagation();
      };
      var highlight = function () {
        els.dropZone.className = "file-drop-zone dragover";
      };
      var unhighlight = function () {
        els.dropZone.className = "file-drop-zone";
      };

      els.dropZone.addEventListener("dragenter", preventDefaults);
      els.dropZone.addEventListener("dragover", function (e) {
        preventDefaults(e);
        highlight();
      });
      els.dropZone.addEventListener("dragleave", function (e) {
        preventDefaults(e);
        unhighlight();
      });
      els.dropZone.addEventListener("drop", function (e) {
        preventDefaults(e);
        unhighlight();
        if (
          e.dataTransfer &&
          e.dataTransfer.files &&
          e.dataTransfer.files.length
        ) {
          els.attachment.setAttribute("data-touched", "true");
          // Merge dropped files into selectedFiles
          for (var i = 0; i < e.dataTransfer.files.length; i++) {
            state.selectedFiles.push(e.dataTransfer.files[i]);
          }
          if (state.selectedFiles.length > CONFIG.maxFiles) {
            state.selectedFiles = state.selectedFiles.slice(0, CONFIG.maxFiles);
          }
          syncFileInput();
          if (validateFiles(true)) {
            state.selectedFiles = [];
            syncFileInput();
          }
          renderFileList();
          updateFileSummary();
          validate();
        }
      });
    }

    // Initialize character count
    updateCharCount();

    // Restore any auto-saved draft
    restoreFormState();

    // Listen for online/offline events to proactively notify user
    window.addEventListener("online", function () {
      validate();
    });
    window.addEventListener("offline", function () {
      els.btn.disabled = true;
      els.btn.setAttribute("aria-disabled", "true");
    });

    // Turnstile may have loaded before this script
    if (window.turnstile && state.widgetId === null) window.onTurnstileLoaded();
  }

  // Safe DOM-ready: works even if DOMContentLoaded already fired
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
